import {
  CONSENT_LOADING,
  CONSENT_DATA,
  CONSENT_ERROR,
  CONSENT_SUBMITTING,
} from './ConsentActions';

const INITIAL_STATE = {
  loading: true,
  submitting: false,
  error: null,
  clientId: null,
  clientName: null,
  redirectDomain: null,
};

const ConsentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONSENT_LOADING:
      return { ...state, loading: true, error: null };
    case CONSENT_DATA:
      return {
        ...state,
        loading: false,
        clientId: action.payload.clientId,
        clientName: action.payload.clientName,
        redirectDomain: action.payload.redirectDomain,
      };
    case CONSENT_SUBMITTING:
      return { ...state, submitting: action.payload };
    case CONSENT_ERROR:
      return { ...state, loading: false, submitting: false, error: action.payload };
    default:
      return state;
  }
};

export default ConsentReducer;
